"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = ["id"];
const _hoisted_3 = {
    key: 0,
    class: "text-xs ml-1"
};
const _hoisted_4 = {
    key: 1,
    class: "text-xs ml-1"
};
const tagStore_1 = require("../../../stores/tag/tagStore");
const i18n_1 = require("../../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ListPriceHeaderCell',
    props: {
        ariaSort: { default: 'none' },
        tableId: null
    },
    emits: ["toggle-sort"],
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.listPriceColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", {
                    key: 0,
                    id: `${__props.tableId}-list-price-header-cell`,
                    class: "text-left font-bold bg-gray-darker text-white px-4 py-2 select-none"
                }, [
                    (0, vue_2.createElementVNode)("button", {
                        id: `${__props.tableId}-list-price-header-cell-button`,
                        type: "button",
                        class: "inline-flex items-center gap-2 hover:text-gray-200 focus:outline-none",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('toggle-sort')))
                    }, [
                        (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('list_price', 'List price', 'list_price_header_cell')), 1),
                        (__props.ariaSort &&
                            ['none', 'ascending', 'descending'].includes(__props.ariaSort) &&
                            !(0, vue_2.unref)(tagStore).tags.switches.pairSearchSwitch.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", {
                                key: 0,
                                class: (0, vue_2.normalizeClass)(__props.ariaSort === 'ascending'
                                    ? 'marso-icon-sort-asc'
                                    : __props.ariaSort === 'descending'
                                        ? 'marso-icon-sort-desc'
                                        : 'marso-icon-unsorted text-gray-dark')
                            }, null, 2))
                            : (0, vue_2.createCommentVNode)("", true)
                    ], 8, _hoisted_2),
                    ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('gross', 'gross', 'list_price_header_cell')), 1))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('net', 'net', 'list_price_header_cell')), 1))
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
